const $ = require('jquery');

$('#nav_collapse .d-block .dropdown-toggle .js-child-trigger').click(function (e) {
	$('#child_dropdown_menu_container').find('.dropdown-menu').remove();
	$(this).parent().find('.dropdown-menu').clone().show().appendTo('#child_dropdown_menu_container');
	$('#nav_collapse').toggleClass('open_child');
	e.preventDefault();
});
$('.close_child').click(function(e){
	$('#nav_collapse').toggleClass('open_child');
	e.preventDefault();
});
